/* globals window */
/* INCIDENTRESOURCEMODAL.JS */
/* THIS IS A CLASS BASED COMPONENT AND DIFFERENT FROM THE OTHERS,IT NEEDS UPDATE LATER..*/
/* it uses this.props instead of useEffect and useRef.. */
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Moment from 'moment'
import { hideModal } from '../../actions/modal'
import { fetchReport } from '../../actions/report' // xt 6-25-25 why is it using this action/db
//import { Modal, ListGroup, ListGroupItem } from 'react-bootstrap'
import { IntlProvider, FormattedDate, FormattedTime } from 'react-intl'
import MapNewGoogle from "../../components/MapNewGoogle/MapNewGoogle";
//import Map from '../Map/Map'
import './IncidentResourceModal.css'

class IncidentResourceModal extends Component {
  constructor (props) {
    super(props)

    Moment.updateLocale('en', {
      relativeTime: {
        future: '%s',
        past: '%s',
        s: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
      }
    })

    this.hide = this.hide.bind(this)
    this.getReportCoords = this.getReportCoords.bind(this)
    this.getStateValueCoords = this.getStateValueCoords.bind(this)
    this.getCoords = this.getCoords.bind(this)
    this.getMapCenterCoords = this.getMapCenterCoords.bind(this)
  }
// new code from chatgp
  componentDidMount () {
  const { dispatch, modalProps } = this.props;
  const incident = modalProps?.incident;

  if (!incident) {
    console.warn('incident is undefined in componentDidMount');
    return;
  }

  dispatch(fetchReport(incident.agency_id, incident.report_schema_id, incident._id));
}

  hide () {
    const { dispatch } = this.props

    dispatch(hideModal())
  }

  getReportCoords() {
    const {
      report,
      agency,
      languageCode,
      incident
    } = this.props

    let agencySchema = agency.report_schemas.find((schema) => schema._id === incident.report_schema_id)
    let defaultStateId = agencySchema.default_state_id
    let newReportState = agencySchema.report_states.find((state) => state._id === defaultStateId)
    let reportCoordinates = [{title: newReportState.title[languageCode], markerColor: newReportState.color}]

    if(report && report.coordinate) {

      let {latitude, longitude} = report.coordinate

  reportCoordinates.coordinates = {
    lat: latitude,
    lng: longitude
    }

    }

   return reportCoordinates
  }

  getStateValueCoords() {
    const {
      report,
      agency,
      languageCode,
      incident
    } = this.props
    let agencySchema = agency.report_schemas.find((schema) => schema._id === incident.report_schema_id)
    let reportStateValues = report.report_state_values || []

    let stateValueCoords = []

    reportStateValues.map(stateValue => {
      if (stateValue.coordinate) {

      let stateInfo = agencySchema.report_states.find((state) => state._id === stateValue.report_state_id)
        stateValueCoords.push({
          coordinates: {
            lat: stateValue.coordinate.latitude,
            lng: stateValue.coordinate.longitude
          },
          title: stateInfo.title[languageCode],
          markerColor: stateInfo.color,
          received: stateValue.received,
        })
        console.log(stateValueCoords, 'I am the StateValue Function returning my coords');

    }

    return stateValueCoords
  })
  }

  getMapCenterCoords() {
    const {agency} = this.props
    const agencyMapCenter = agency.map_center
    
    const centerpoint = {
    lat: agencyMapCenter.latitude || 0,
    lng: agencyMapCenter.longitude || 0
  };
    return {
      coordinates: centerpoint
    };

  }

  getCoords () {
    const {
      report
    } = this.props

    let coords = []

    //in the case there is no report use last resort coords
    if(report === undefined || (report.coordinate === undefined && report.report_state_values === undefined)) {
      console.log("No Report")
      let result = this.getMapCenterCoords()
      coords.push(result)
    } else {
      //There is a Report to get data from
      if (report.coordinate === undefined && report.report_state_values.length <= 0){
        console.log("No Report Coordinates, No Report State Values")
        let result = this.getMapCenterCoords()
        coords.push(result)
      } else if (report.coordinate) {
        console.log("Report Coordinates")
        let result = this.getReportCoords()
        coords.push(result)
      } else if (report.coordinate === undefined && report.report_state_values.length > 0) {
          console.log("No Report Coordinates, Report State Values")
        //let result = this.getStateValueCoords()
          let result = this.getMapCenterCoords()
        coords.push(result)
      } else {
          console.log("In final else")
      }
    }
    console.log(coords)
    return coords
  }

  render () {
  const { modalProps, visible, agency, report, languageCode } = this.props;

  // Defensive check BEFORE destructuring
  if (!modalProps?.incident || !modalProps.incident.report_schema_id) {
    return <div>Loading incident data…</div>;
  }

  // Now safe to destructure
  const incident = modalProps.incident;

  // Continue using `incident`, `agency`, `report`, etc.

// Now safe to destructure
  

    let agencySchema = agency.report_schemas.find((schema) => schema._id === incident.report_schema_id)
    let reportStateValues = report.report_state_values || []
    let defaultStateId = agencySchema.default_state_id
    let newReportState = agencySchema.report_states.find((state) => state._id === defaultStateId)
    let defaultReceived = Moment(report.received)

    const centerpoint = {
  lat: agency?.map_center?.latitude || 0,
  lng: agency?.map_center?.longitude || 0
};

const coordinatePoints = {
  coordinates: {
    lat: report?.coordinate?.latitude || centerpoint.lat,
    lng: report?.coordinate?.longitude || centerpoint.lng
  },
  location: report?.location_description_translation?.en_US || report?.location || 'N/A',
  type: report?.incident_type_translation?.en_US || report?.incident_type || 'Unknown',
  received: report?.received || '',
  occurred: report?.occurred || '',
  name: agency?.name || '',
  incident_number: incident?.display_title || '',
  color: '#1033e4'
};
    return (
  visible && (
    <>
      <div className="modal-backdrop fade show"></div>

      <div
        className="resource-modal show d-block"
        id="resource-modal"
        tabIndex="-1"
        role="dialog"
        aria-modal="true"
      >
        <div className="resource-modal-dialog modal-lg" role="document">
          <div className="resource-modal-content">
            <div className="resource-modal-header">
              <h5 className="modal-title d-flex align-items-center">
                <i className="material-icons me-2">check_circle</i>
                <span className="image-text">
                  Responder History - {incident.display_title}
                </span>
              </h5>
              <button
                type="button"
                className="resource-modal-close"
                aria-label="Close"
                onClick={this.hide}
              >Close X
              </button>

            </div>

            <div className="modal-body" id="resource-modal-body">
              <div id="map">
                {/* <Map coords={this.getCoords()} /> */}
               <MapNewGoogle coords={coordinatePoints} center={centerpoint} agency={agency} />
              </div>

              <IntlProvider locale="en">
                <ul className="list-group text-medium resource-list">
                  {reportStateValues
                    .sort((first, second) =>
                      first.received > second.received ? -1 : 1
                    )
                    .map((stateValue, index) => {
                      const reportState = agencySchema.report_states.find(
                        (state) => state._id === stateValue.report_state_id
                      );
                      const received = Moment(stateValue.received);
                      const elapsedTime =
                        index === reportStateValues.length - 1
                          ? null
                          : received.to(reportStateValues[index + 1].received);

                      return (
                        <li key={index} className="list-group-item">
                          <svg height="40px" width="40px">
                            <circle
                              cx="20"
                              cy="20"
                              r="18"
                              style={{ fill: reportState.color }}
                            />
                          </svg>
                          <div className="resource-display">
                            <div className="resource-name">
                              {reportState.title[languageCode]}
                            </div>
                            <div className="history-times text-small">
                              <FormattedDate
                                value={received}
                                month="numeric"
                                day="numeric"
                                year="2-digit"
                              />{" "}
                              <FormattedTime
                                value={received}
                                hour12={false}
                              />
                            </div>
                          </div>
                          <div className="elapsed-time text-small">
                            {elapsedTime}
                          </div>
                        </li>
                      );
                    })}

                  <li className="list-group-item">
                    <svg height="40px" width="40px">
                      <circle
                        cx="20"
                        cy="20"
                        r="18"
                        style={{ fill: newReportState.color }}
                      />
                    </svg>
                    <div className="resource-display">
                      <div className="resource-name">
                        {newReportState.title[languageCode]}
                      </div>
                      <div className="history-times text-small">
                        <FormattedDate
                          value={defaultReceived}
                          month="numeric"
                          day="numeric"
                          year="2-digit"
                        />{" "}
                        <FormattedTime value={defaultReceived} hour12={false} />
                      </div>
                    </div>
                  </li>
                </ul>
              </IntlProvider>
            </div>
          </div>
        </div>
      </div>
    </>
  )
);
  }
}

const mapStateToProps = (state) => {
  return {
    report: state.report.report || {},
    agency: state.agency.details || {}
  }
}

export default connect(mapStateToProps)(IncidentResourceModal)
